import { Type, type Static } from '@sinclair/typebox';
import { CompanyKey, PartnerUserId, Role } from '../../web/interfaces/companies';
import { createSchema } from '../../util/schema';

export const PartnerCreateUserRequest = Type.Object(
  {
    companyId: Type.Integer({ description: "The partner's own company id; must already exist via a tearsheet POST." }),
    email: Type.String({ format: 'email' }),
    firstName: Type.String({ minLength: 1 }),
    lastName: Type.String({ minLength: 1 }),
  },
  { $id: 'PartnerCreateUserRequest' },
);
export type PartnerCreateUserRequest = Static<typeof PartnerCreateUserRequest>;
export const partnerCreateUserRequestSchema = createSchema(PartnerCreateUserRequest);

export const PartnerCreateUserResponse = Type.Object(
  {
    userId: PartnerUserId,
    email: Type.String({ format: 'email' }),
    companyKey: CompanyKey,
    role: Role,
  },
  { $id: 'PartnerCreateUserResponse' },
);
export type PartnerCreateUserResponse = Static<typeof PartnerCreateUserResponse>;
export const partnerCreateUserResponseSchema = createSchema(PartnerCreateUserResponse);
